import { catalogs } from './catalogs';
import { documents } from './documents';
import { others } from './others';
import { reports } from './reports';
// eslint-disable-next-line import/no-cycle
import ListerSelectors from '../listers_selectors';

export { catalogs, documents, reports };
export { dataTypes } from './datatypes';

/**
 * @const
 * @type {object}
 * @property {Object} cat
 * @property {Object} doc
 */
const meta = {
  cat: catalogs,
  doc: documents,
  other: others,
  rep: reports,
};

const plainMeta = Object.keys(meta).reduce((R, type) => [
  ...R,
  ...Object.keys(meta[type]).reduce((R2, model) => [...R2, {
    ...meta[type][model],
    modelType: type,
    modelName: model,
    ...(ListerSelectors[type] ? ListerSelectors[type][model] : {}),
  }], []),
], []);

export const getSelectorByBackend = (backend) => {
  const selector = plainMeta
    .filter((m) => m.backend === backend)
    .reduce((R, r) => r.selector, null);
  if (!selector) {
    console.error(`No selector found by backend string ${backend} in `, plainMeta);
  }

  return selector;
};

export const getFrontEndByBackend = (backend) => {
  const models = plainMeta.filter((m) => m.backend === backend);
  if (!models.length) {
    console.error(`No selector found by backend string ${backend} in `, plainMeta);
    return null;
  }
  return models[0].frontend;
};

const modelTypes = ['cat', 'doc', 'other'];

export const metaBackends = modelTypes.reduce((RM, modelType) => ({
  ...RM,
  ...Object.keys(meta[modelType]).reduce((R, modelName) => ({
    ...R,
    [meta[modelType][modelName].backend]: {
      ...meta[modelType][modelName],
      modelType,
      modelName,
    },
  }), RM),
}), {});

export default meta;
